import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { IImpersonationContextComponentProps } from '../../../../../../models';
import { convertRawRichTextContentStateToRichContentEditorState } from '../../../../../../models/UiUtils';
import { RichContentDocumentEditor } from '../../../../../components/richContent/RichContentDocumentEditor';
import { MultiCampaignTemplateItem } from '../../MultiCampaignTemplateItem';
import { GeneratingContentLoader } from './generatingContentLoader';
import { styleSheet } from './styles';

export function MultiEmailTemplateItem(
	props: React.PropsWithChildren<
		{
			name: React.ReactNode;
			content: Api.IRawRichTextContentState;
			scheduled?: boolean;
			scheduleDate: Date;
			onUpdateDate: (newDate: Date) => void;
			onRemove: () => void;
			onEdit?: () => void;
			sendFrom: Api.ISendEmailFrom;
			sendFromUserId?: string;
			error?: Api.IOperationResultNoValue;
			postedOn?: Date | string;
			isGeneratingContent: boolean;
			generationFailed: boolean;
			onGenerateContent: () => void;
			onShowOriginalContent: () => void;
			showOriginalContent: boolean;
		} & IImpersonationContextComponentProps
	>
) {
	const {
		name,
		content,
		scheduled,
		error,
		postedOn,
		isGeneratingContent,
		generationFailed,
		onGenerateContent,
		onShowOriginalContent,
		showOriginalContent,
		...restProps
	} = props;

	return (
		<MultiCampaignTemplateItem
			showSuccess={scheduled}
			{...restProps}
			name={name}
			postedOn={postedOn}
			isEmail
			generationFailed={generationFailed}
			onGenerateContent={onGenerateContent}
			isGeneratingContent={isGeneratingContent}
			onShowOriginalContent={onShowOriginalContent}
			showOriginalContent={showOriginalContent}
		>
			<div className={css(styleSheet.emailEditorContainer, error ? styleSheet.editorContainerError : null)}>
				<GeneratingContentLoader isGeneratingContent={isGeneratingContent} />

				<RichContentDocumentEditor
					readOnly
					contentState={convertRawRichTextContentStateToRichContentEditorState(content)}
					styles={[styleSheet.emailEditorStyles]}
				/>
			</div>
		</MultiCampaignTemplateItem>
	);
}
